import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { routes } from "./Route";
import useUser from "../hooks/useUser";
import Loader from "../Layout/Loader/Loader";
import MenusPage from "../Pages/Menus";
import AssignUserMenuPage from "../Pages/Menus/AssignUserMenu";

const Layout = lazy(() => import("../Layout/Layout"));

const RoleBaseRoute = lazy(() => import("./RoleBasedRoute"));

const Error400 = lazy(
  () => import("../Pages/OtherPages/Error/Error400/Error400"),
);
const Unauthorized = lazy(() => import("../Pages/OtherPages/Unauthorized"));

const LayoutRoutes = () => {
  const user = useUser();

  if (!user) {
    return null;
  }

  return (
    <Routes>
      <Route element={<Layout />} key="layout">
        <Route path="/menus" element={<MenusPage />} />
        <Route path="/menus/assign-user-menu" element={<AssignUserMenuPage />} />
      </Route>
      {user &&
        routes.map(({ path, Component, allowedRoles }, i) => (
          <Route element={<Layout />} key={path}>
            <Route
              path={path}
              element={
                <Suspense fallback={<Loader />}>
                  <RoleBaseRoute
                    key={path}
                    path={path}
                    allowedRoles={allowedRoles}
                    userRole={user?.user_type?.toLowerCase()}
                    userId={user?.id}
                  >
                    {Component}
                  </RoleBaseRoute>
                </Suspense>
              }
            />
          </Route>
        ))}
      <Route
        path="/unauthorized"
        element={
          <Suspense fallback={<Loader />}>
            <Unauthorized />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <Suspense fallback={<Loader />}>
            <Error400 />
          </Suspense>
        }
      />
    </Routes>
  );
};

export default LayoutRoutes;
